import {
  UserAvailabilityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';

export const mapToUserSetAvailabilityStatus = (
  status: UserAvailabilityStatus,
): UserSetAvailabilityStatus | null => {
  switch (status) {
    case UserAvailabilityStatus.Available:
      return UserSetAvailabilityStatus.Available;
    case UserAvailabilityStatus.AwayFromDesk:
      return UserSetAvailabilityStatus.AwayFromDesk;
    case UserAvailabilityStatus.Break:
      return UserSetAvailabilityStatus.Break;
    case UserAvailabilityStatus.ExtendedWrapUp:
      return UserSetAvailabilityStatus.ExtendedWrapUp;
    case UserAvailabilityStatus.Offline:
      return UserSetAvailabilityStatus.Offline;
    case UserAvailabilityStatus.Unavailable:
      return UserSetAvailabilityStatus.Unavailable;
    // UserAvailabilityStatus.CallOffer, OnACall, WrapUp have no mapping
    default:
      return null;
  }
};
